/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Retailer } from './Retailer';
// @ts-ignore
import {
// @ts-ignore
    RetailerFromJSON,
// @ts-ignore
    RetailerFromJSONTyped,
// @ts-ignore
    RetailerToJSON,
} from './Retailer';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';
// @ts-ignore
import type { StoreAddress } from './StoreAddress';
// @ts-ignore
import {
// @ts-ignore
    StoreAddressFromJSON,
// @ts-ignore
    StoreAddressFromJSONTyped,
// @ts-ignore
    StoreAddressToJSON,
} from './StoreAddress';
// @ts-ignore
import type { StoreOrderPrediction } from './StoreOrderPrediction';
// @ts-ignore
import {
// @ts-ignore
    StoreOrderPredictionFromJSON,
// @ts-ignore
    StoreOrderPredictionFromJSONTyped,
// @ts-ignore
    StoreOrderPredictionToJSON,
} from './StoreOrderPrediction';
// @ts-ignore
import type { StoreReceivingWindow } from './StoreReceivingWindow';
// @ts-ignore
import {
// @ts-ignore
    StoreReceivingWindowFromJSON,
// @ts-ignore
    StoreReceivingWindowFromJSONTyped,
// @ts-ignore
    StoreReceivingWindowToJSON,
} from './StoreReceivingWindow';

/**
 * 
 * @export
 * @interface Store
 */
export interface Store {
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    retailerId: string;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    organizationId: string;
    /**
     * Contextual field – customer code specific to the supplier-store relation
     * @type {string}
     * @memberof Store
     */
    customerCode?: string;
    /**
     * Contextual field – minimum order quantity specific to the supplier-store relation
     * @type {number}
     * @memberof Store
     */
    moq?: number;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    externalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    contactCountryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    contactNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    currencyCode: string;
    /**
     * 
     * @type {Status}
     * @memberof Store
     */
    status: Status;
    /**
     * 
     * @type {Array<StoreAddress>}
     * @memberof Store
     */
    addresses: Array<StoreAddress>;
    /**
     * 
     * @type {boolean}
     * @memberof Store
     */
    showVat: boolean;
    /**
     * 
     * @type {Array<StoreReceivingWindow>}
     * @memberof Store
     */
    receivingWindows: Array<StoreReceivingWindow>;
    /**
     * 
     * @type {StoreOrderPrediction}
     * @memberof Store
     */
    orderPrediction: StoreOrderPrediction;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Store
     */
    customData: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Store
     */
    dynamicFields: { [key: string]: string; };
    /**
     * 
     * @type {Retailer}
     * @memberof Store
     */
    retailer?: Retailer;
    /**
     * 
     * @type {Date}
     * @memberof Store
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the Store interface.
 */
// @ts-ignore
export function instanceOfStore(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "retailerId" in value;
    isInstance = isInstance && "organizationId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "addresses" in value;
    isInstance = isInstance && "showVat" in value;
    isInstance = isInstance && "receivingWindows" in value;
    isInstance = isInstance && "orderPrediction" in value;
    isInstance = isInstance && "customData" in value;
    isInstance = isInstance && "dynamicFields" in value;

    return isInstance;
}

// @ts-ignore
export function StoreFromJSON(json: any): Store {
    return StoreFromJSONTyped(json, false);
}

// @ts-ignore
export function StoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): Store {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'retailerId': json['retailer_id'],
        'organizationId': json['organization_id'],
        'customerCode': !exists(json, 'customer_code') ? undefined : json['customer_code'],
        'moq': !exists(json, 'moq') ? undefined : json['moq'],
        'name': json['name'],
        'email': json['email'],
        'externalCode': !exists(json, 'external_code') ? undefined : json['external_code'],
        'contactCountryCode': !exists(json, 'contact_country_code') ? undefined : json['contact_country_code'],
        'contactNumber': !exists(json, 'contact_number') ? undefined : json['contact_number'],
        'description': json['description'],
        'currencyCode': json['currency_code'],
        'status': StatusFromJSON(json['status']),
        'addresses': ((json['addresses'] as Array<any>).map(StoreAddressFromJSON)),
        'showVat': json['show_vat'],
        'receivingWindows': ((json['receiving_windows'] as Array<any>).map(StoreReceivingWindowFromJSON)),
        'orderPrediction': StoreOrderPredictionFromJSON(json['order_prediction']),
        'customData': json['custom_data'],
        'dynamicFields': json['dynamic_fields'],
        'retailer': !exists(json, 'retailer') ? undefined : RetailerFromJSON(json['retailer']),
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
    };
}

// @ts-ignore
export function StoreToJSON(value?: Store | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'retailer_id': value.retailerId,
        'organization_id': value.organizationId,
        'customer_code': value.customerCode,
        'moq': value.moq,
        'name': value.name,
        'email': value.email,
        'external_code': value.externalCode,
        'contact_country_code': value.contactCountryCode,
        'contact_number': value.contactNumber,
        'description': value.description,
        'currency_code': value.currencyCode,
        'status': StatusToJSON(value.status),
        'addresses': ((value.addresses as Array<any>).map(StoreAddressToJSON)),
        'show_vat': value.showVat,
        'receiving_windows': ((value.receivingWindows as Array<any>).map(StoreReceivingWindowToJSON)),
        'order_prediction': StoreOrderPredictionToJSON(value.orderPrediction),
        'custom_data': value.customData,
        'dynamic_fields': value.dynamicFields,
        'retailer': RetailerToJSON(value.retailer),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
    };
}

